import React from "react";

type Props = {};

const MunicipalTaxHint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <ul className="text-start text-greyDark leading-para">
        <li>
          Municipal tax refers to the tax levied on the property held by you by the municipal
          authority or local body of the respective city or state. It is commonly known as property
          tax.
        </li>
        <li>
          The value of municipal Tax payable is calculated based on the type of your property i.e
          commercial or residential and total squarefeet measurement of your property.
        </li>
        <li>
          You can download the municipal tax paid receipt from the official website of the municipal
          corporation or local body.
        </li>
      </ul>
    </>
  );
};

export default MunicipalTaxHint;
